/// <reference path="../types/index.d.ts" />

import '../client_forms/tcasowawed/style.css';
import FormStructure from './tcasowawed/form_structure';

export default FormStructure;